// extracted by mini-css-extract-plugin
module.exports = {"EmptyState":"empty_state_EmptyState__39alv","illustration":"empty_state_illustration__2YW3A","details":"empty_state_details__1aWkY"};